import { render, staticRenderFns } from "./autoFormatters.vue?vue&type=template&id=87864fc6&"
import script from "./autoFormatters.vue?vue&type=script&lang=js&"
export * from "./autoFormatters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports